// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_in_stock_only_true_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Only show shoes available within 2-3 working days.`
};

const el_in_stock_only_true_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Δείξε μόνο παπούτσια διαθέσιμα εντός 2-3 εργάσιμων ημερών.`
};

const ru_in_stock_only_true_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Показать только обувь, доступную в течение 2-3 рабочих дней.`
};

const he_in_stock_only_true_expl = /** @type {(inputs: {}) => string} */ () => {
	return `הצג רק נעליים הזמינות תוך 2-3 ימי עסקים.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const in_stock_only_true_expl = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.in_stock_only_true_expl(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("in_stock_only_true_expl", locale)
	if (locale === "en") return en_in_stock_only_true_expl(inputs)
	if (locale === "el") return el_in_stock_only_true_expl(inputs)
	if (locale === "ru") return ru_in_stock_only_true_expl(inputs)
	if (locale === "he") return he_in_stock_only_true_expl(inputs)
	return "in_stock_only_true_expl"
};